import { render, staticRenderFns } from "./datagridCard.vue?vue&type=template&id=96fb199e&"
import script from "./datagridCard.vue?vue&type=script&lang=js&"
export * from "./datagridCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/list/datagridCard.vue"
export default component.exports